
import { useState } from "react";
const useFeaturedImage = ({ attributes, setAttributes }) => {

  const [valueForWidth, setValueForWidth] = useState(false);
  const [toggleGroupControlState, settoggleGroupControlState] = useState(false);
  const [widthController, setWidthController] = useState(false);
  const [alignment, setAlignment] = useState(false);

  const handleResolutionChange = (selectedResolution) => {

    settoggleGroupControlState(true);
    // Set ImgWidth based on selected resolution
    let newWidth;
    let newHeight;
    switch (selectedResolution) {
      case "thumbnail":
        newWidth = 150;
        newHeight = 150;
        break;
      case "medium":
        newWidth = 300;
        newHeight = 300;
        break;
      case "large":
        newWidth = 1024;
        newHeight = 1024;
        break;
      default:
        newWidth = attributes?.ImgWidth;
        newHeight = attributes?.height;
        break;
    }

    // Convert to strings with "px" appended for CSS properties
    const widthString = `${newWidth}px`;
    const heightString = `${newHeight}px`;

    setValueForWidth(false);
    setWidthController(false);

    setAttributes({
      ...attributes,
      ImgWidth: widthString,
      height: heightString,
      imageUrl: selectedResolution,
      valueForWidth: false,
      selectedImageTogggler: true,
      widthPercentageState: false,
      widthController: false,
    });
  };

  // Function to handle width change
  const handleWidthChange = (newWidth) => {

    setValueForWidth(false);
    setWidthController(true);
    const updatedWidth = `${newWidth}px`;
    setAttributes({
      ...attributes,
      ImgWidth: updatedWidth,
      valueForWidth: valueForWidth,
      selectedImageTogggler: false,
      widthPercentageState: false,
      widthController: true,
    });
  };

  // Function to handle height change
  const handleHeightChange = (newHeight) => {

    setValueForWidth(false);
    settoggleGroupControlState(false);

    setWidthController(true);
    const updatedHeight = `${newHeight}px`;
    setAttributes({
      ...attributes,
      height: updatedHeight,
      valueForWidth: valueForWidth,
      selectedImageTogggler: false,
      widthPercentageState: false,
      widthController: true,
    });

  };

  const handleAlignmentChange = (alignment) => {
  
    setAlignment(alignment);
    let widthPercentage;
    const imgWidth = getImageWidth(attributes.imageUrl); // Get the appropriate width based on the imageUrl
    switch (alignment) {
      case "left":
        widthPercentage = imgWidth * 0.25 + "px"; // 25% of the image width
        break;
      case "center":
        widthPercentage = imgWidth * 0.5 + "px"; // 50% of the image width
        break;
      case "right":
        widthPercentage = imgWidth * 0.75 + "px"; // 75% of the image width
        break;
      case "justify":
        widthPercentage = imgWidth + "px"; // 100% of the image width
        break;
      default:
        widthPercentage = imgWidth + "px"; // Default to 100% of the image width
        break;
    }

    settoggleGroupControlState(false);
    setValueForWidth(true);
    setWidthController(false);
    setAttributes({
      ...attributes,
      widthPercentage: widthPercentage,
      valueForWidth: true,
      selectedImageTogggler: false,
      widthPercentageState: true,
      widthController: false,
    });

  };

  const getImageWidth = (imageUrl) => {

    switch (imageUrl) {
      case "thumbnail":
        return 150; // Thumbnail width
      case "medium":
        return 300; // Medium width
      case "large":
        return 1024; // Large width
      default:
        return 1024; // Default to large width if imageUrl is not recognized
    }

  };

  const getMaxHeightAndWidth = (imageUrl) => {

    switch (imageUrl) {
      case "thumbnail":
        return 150;
      case "medium":
        return 300;
      case "large":
        return 1024;
      default:
        return 1024; // Default max value
    }

  };

  return {

    getMaxHeightAndWidth,
    handleAlignmentChange,
    handleWidthChange,
    handleResolutionChange,
    handleHeightChange,
    toggleGroupControlState,
    widthController,
    alignment,
  };
  
};

export default useFeaturedImage;
